module.exports = __webpack_public_path__ + "static/media/camion.ec3670dc.svg";